import React, { useEffect, useRef, useState } from 'react';
import { FaRegEye } from 'react-icons/fa6';
import { InfinitySpin } from 'react-loader-spinner';
import {  IoMdClose } from 'react-icons/io';
import AddSales from './AddSales';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { api_url } from '../../../config';
import SaleDetail from './SaleDetail';
import { clearCart } from '../../../Redux/SalesSlice';
import { useLocation } from 'react-router';
import { hasPermission } from '../../../Redux/permissionSlice';
import { selectRoles } from '../../../Redux/AuthSlice';
import api from '../../../utils/api';
import { ExpandableProductList } from '../../../utils/ExpandableCells';
import { getPageNumbers } from '../../../utils/getPageNumbers';
import Table from '../../../components/dataUi/Table';
import { FaGreaterThan } from "react-icons/fa";
import { formatDate } from '../../../utils/dateUtils';

const SalesInfo = () => {
    const [sales, setSales] = useState([])
    const [sale, setSale] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedDropdown, setSelectedDropdown] = useState(null);
    const [showModal, setShowModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const modalRef = useRef();
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState();
    const [limit, setLimit] = useState(50)
    const [sales_limit, setSales_limit] = useState('')
    const [filter_action, setFilter_action] = useState(null)
    const [filter_by, setFilter_by] = useState('')
    const [start_date, setStart_date] = useState('')
    const [end_date, setEnd_date] = useState('')
    const [showbtn, setShowbtn] = useState(true)
    const [sale_view, setSale_view] = useState(false)

    const [sortby, setSortby] = useState('-created_at')
    const [metadata, setMetadata] = useState('')


    const dispatch = useDispatch()
    const location = useLocation();


    const getPath = (specificPath) => {
        return location.pathname === specificPath;
    };
    const isRender = getPath('/wholesale/dashboard');



    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const handleNextPage = () => {
        if (currentPage < lastPage) {
            setCurrentPage(currentPage + 1);

        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    useEffect(() => {
        // Function to handle click outside of modal
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowModal(false);
                setEditModal(false)
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        // Function to handle click outside of modal
        const handleClickOutside = (event) => {
            if (popUpRef.current && !popUpRef.current.contains(event.target)) {
                setSelectedDropdown(null);
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const popUpRef = useRef();
    const toggleSalesForm = () => {
        dispatch(clearCart())
        setShowModal(!showModal)
    };

    const { id, branch_id, token } = useSelector((state) => state.auth)

    const handleFilterDate = (start_date, end_date) => {
        setShowbtn(false)
        if (start_date === '' && end_date === '') {
            setFilter_by('');
        } else {
            setFilter_by('dates');
        }
        setFilter_action(!filter_action)

    };

    // Handle date filter for Table component
    const handleDateFilter = ({ startDate, endDate }) => {
        setStart_date(startDate || '');
        setEnd_date(endDate || '');
        handleFilterDate(startDate || '', endDate || '');
    };


    const fetchSaleTransactions = async (page, limit) => {
        setLoading(loading);
        if (!navigator.onLine) {
            toast("You're offline");
            setLoading(false);
            return;
        }
        try {
            const params = {
                page: page || 1,
                limit: limit || 50,
                sort: sortby,
                [`filter[${filter_by}]`]: `${start_date},${end_date}`
            };
            // if (filter_by) {
            //     params[`filter[${filter_by}]`] = `${start_date},${end_date}`;
            // }

            const response = await api.get(`${api_url}/api/v1/wholesaler/user/${id}/branch/${branch_id}/transaction`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                params
            });
            const data = response.data.data;
            const meta = response.data.meta
            setMetadata(meta)

            setSales(data);
            setSales_limit(response.data.meta.total);
            setLastPage(response.data.meta.last_page);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };



    const showSaleDetail = (data) => {
        setSale_view(!sale_view)
        setSale(data)
    }

    const selectedRoles = useSelector(selectRoles);
    const roles = Array.isArray(selectedRoles) ? selectedRoles : selectedRoles.split(',').map(role => role.trim());

    // Format sales data for Table component
    const formatSalesForTable = () => {
        return sales.map((sale, index) => {
            const productsString = sale.stock?.map(item => {
                const productName = item?.inventory?.name || 'Unknown Product';
                const manufacturer = item?.inventory?.manufacturer || 'Unknown Manufacturer';
                const quantity = item.quantity || 0;
                const price = item.amount || 0;
                const supplier = item?.contact?.name || 'Unknown Supplier';

                return `${productName}\nManufacturer: ${manufacturer}\nQuantity: ${quantity}\nPrice: ${price}\nSupplier: ${supplier}`;
            }).join('\n\n') || 'No products';

            return {
                no: index + 1,
                id: sale.id,
                retailer_name: sale.contact.name,
                products: productsString,
                amount: sale.amount.toLocaleString(),
                date_sold: formatDate(new Date(sale?.date_sold).toLocaleDateString()),
                personnel: `${sale?.user?.first_name} ${sale?.user?.last_name}`,
                _originalData: sale
            };
        });
    };

    // Make sure the ProductListCell displays raw strings correctly
    const ProductListCell = ({ value }) => {
        if (!value || value === 'No products') {
            return <span className="text-gray-500">No products</span>;
        }

        const products = value.split('\n\n');
        const firstProduct = products[0];
        const lines = firstProduct.split('\n');
        const productName = lines[0];
        const details = lines.slice(1).join(' | ');

        return (
            <div className="flex flex-row items-center gap-1 truncate">
                <p className="text-sm font-medium">{productName}</p>
                <p className="text-xs text-gray-600 truncate">{details}</p>
                {products.length > 1 && (
                    <p className="mt-1 text-xs text-gray-500">+{products.length - 1} more products</p>
                )}
            </div>
        );
    };

    // Define table headers
    const tableHeaders = [
        { key: 'no', label: 'No.', sortable: false },
        { key: 'retailer_name', label: 'Retailer Name', sortable: true },
        {
            key: 'products',
            label: 'Products',
            sortable: false,
            render: (row) => <ProductListCell value={row} />
        },
        { key: 'amount', label: 'Total Amount', sortable: true },
        { key: 'date_sold', label: 'Date Sold', sortable: true },
        { key: 'personnel', label: 'Sale Personnel', sortable: false },
    ];

    // Define actions for table rows
    const tableActions = [
        {
            label: 'View',
            variant: 'primary',
            icon: <FaRegEye className="text-xs" />,
            onClick: (row) => showSaleDetail(row._originalData)
        }
    ];

    useEffect(() => {
        fetchSaleTransactions(currentPage, limit);
    }, [id, token, currentPage, limit, filter_by, filter_action, sortby]);




    return (
        <div className='font-lufga'>
            {!sale_view ? <div className='h-full overflow-auto '>
                {loading && ( // Display loader while loading
                    <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm">
                        <InfinitySpin color="#008DDA" loading={loading} size={40} />
                    </div>
                )}
                <div className='mx-6 font-lufga'>
                    {!loading && (
                        <Table
                            headers={tableHeaders}
                            rows={formatSalesForTable()}
                            actions={tableActions}
                            emptyMessage="No sales available"
                            headerBgColor="bg-blue-200"
                            onRowClick={(row) => showSaleDetail(row._originalData)}
                            title="Sales"
                            itemsPerPage={limit}
                            searchPlaceholder="Search by ID, retailer..."
                            onAdd={!isRender && hasPermission(roles, ['transactionWriter', 'transactionAdmin']) ? toggleSalesForm : undefined}
                            addButtonText="Add Sale"
                            addButtonClassName="bg-blue-500 hover:bg-blue-600 text-white"
                            showDateFilter={true}
                            onDateChange={handleDateFilter}
                            dateFilterProps={{
                                placeholder: 'Filter by sale date',
                                startDateLabel: 'Start Date',
                                endDateLabel: 'End Date'
                            }}
                            className="text-xs"
                        />
                    )}

                    {showModal && (
                        <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-800 bg-opacity-50">
                            <div ref={modalRef} className="p-4 bg-white rounded-md shadow-lg min-h-max">
                                <IoMdClose size={24} onClick={toggleSalesForm} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                <AddSales toggle={toggleSalesForm} fetchSaleTransactions={fetchSaleTransactions} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
                :
                <div className='relative'>


                    <div className='mx-10 mt-4'>
                        <p className='text-xl font-semibold lg:text-3xl text-slate-600'>Sale Details</p>

                    </div>
                    <div className='flex items-center gap-2 mx-10 my-2'>
                        <p onClick={() => { setSale_view(false) }} className='flex items-center gap-1 text-blue-700 cursor-pointer'>Sales</p>
                        <p className=''><FaGreaterThan size={14} /></p>
                        <p>Sales Details</p>
                    </div>
                    <div className='grid gap-8 rounded-sm lg:grid-cols-[minmax(50px,250px)_repeat(5,1fr)] lg:gap-0 '>
                        <div className='col-span-4 lg:col-span-1 bg-neutral-100'>
                            <div className='flex flex-col gap-2 max-h-[60vh] overflow-auto'>
                                <div className='sticky top-0 p-2 z-1 bg-neutral-100 w-100'>
                                    <p className='w-full text-sm font-semibold font-lufga'>Sale List</p>
                                    <div>
                                        {/* <input type='text' value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value) }} placeholder='Search Users' className='w-56 sm:w-[150px] focus:outline-none rounded-md shadow-sm border px-2 py-3 h-3 font-lufga text-xs' /> */}
                                    </div>
                                </div>
                                {sales.map((data) => (
                                    <div key={data.id} className={`cursor-pointer mx-2 p-[1rem] shadow-md bg-white hover:bg-slate-200 py-1 ${sale.id === data.id ? 'bg-neutral-200' : ''}`} onClick={() => setSale(data)}>
                                        <p className='text-sm font-semibold leading-5'>{data?.contact?.name}</p>
                                        <p className='text-sm leading-5 text-gray-600'><span className='font-bold'>Amount: </span>{data?.amount}</p>
                                        <p className='text-sm text-blue-600'>{formatDate(new Date(data?.created_at).toLocaleDateString())}</p>
                                    </div>
                                ))}

                            </div>
                            <div className='flex items-center gap-4 mx-4 mt-4'>
                                <button
                                    onClick={handlePrevPage}
                                    disabled={currentPage === 1}
                                    className={currentPage === 1 ? 'text-gray-500 text-xs' : 'text-xs text-blue-600'}
                                >
                                    Prev
                                </button>
                                <div className='flex items-center gap-3'>
                                    {getPageNumbers(currentPage, lastPage).map((pageNumber, index) => (
                                        <React.Fragment key={index}>
                                            {pageNumber === '...' ? (
                                                <span className="text-xs">...</span>
                                            ) : (
                                                <button
                                                    onClick={() => handlePageClick(pageNumber)}
                                                    className={`text-xs ${currentPage === pageNumber ? 'font-bold' : ''}`}
                                                >
                                                    {pageNumber}
                                                </button>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                                <button
                                    onClick={handleNextPage}
                                    disabled={currentPage === lastPage}
                                    className={currentPage === lastPage ? 'text-gray-500 text-xs' : 'text-xs text-blue-600'}
                                >
                                    Next
                                </button>
                            </div>


                        </div>
                        <div className='col-span-4 p-2 lg:col-span-5 '>
                            <p className='text-sm font-bold font-lufga'>Details</p>
                            <div className='max-h-[60vh] overflow-auto'>
                                <SaleDetail toggle={sale_view} data={sale} roles={roles} />

                            </div>

                        </div>

                    </div>
                </div>

            }
        </div>
    );
}

export default SalesInfo;
